import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endponits from "../../backend/endpoints";

/**
 *
 * @param {*} action
 * getting menu list
 */

function* getdataEntryHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endponits.dynamicList(action.payload),
		);
		yield put({
			type: types.GET_DATA_ENTRY_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_DATA_ENTRY_ERROR,
			payload,
		});
	}
}

export function* getdataEntryWatcherSaga() {
	yield takeLatest(types.GET_DATA_ENTRY_START, getdataEntryHandlerSaga);
}

function* createDataEntriesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endponits.deleteDyanamicItem("customer", action.payload),
		);
		yield put({
			type: types.CREATE_DATA_ENTRY_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.CREATE_DATA_ENTRY_ERROR,
			payload,
		});
	}
}

export function* createDataEntriesWatcherSaga() {
	yield takeLatest(types.CREATE_DATA_ENTRY_START, createDataEntriesHandlerSaga);
}
